import React from 'react';
import { motion } from 'framer-motion';
import { BookMockup } from './BookMockup';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="cta-final" className="py-32 bg-olive relative overflow-hidden" data-id="element-109">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-110" />

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-111">
        <div className="text-center mb-16" data-id="element-112">
          <motion.h2 className="text-5xl font-serif text-cream mb-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-113">
            Tu bebé tiene suerte de tenerte
          </motion.h2>
          <motion.p className="text-xl text-cream/80 max-w-2xl mx-auto leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-114">
            No necesitas saberlo todo hoy. Solo necesitas dar el primer paso con
            más tranquilidad, más criterio y más amor. Primeros Bocados fue
            creado para acompañarte en ese comienzo.
          </motion.p>
        </div>

        <div className="flex flex-col items-center" data-id="element-115">
          <motion.div className="flex items-end justify-center gap-[-20px] mb-12 relative" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} data-id="element-116">
            <div className="z-10 transform translate-x-8 translate-y-4 rotate-[-5deg] relative" data-id="element-117">
              <BookMockup title="Plan Semanal" variant="bonus1" size="sm" data-id="element-118" />
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-center" data-id="element-119">
                <span className="text-xs text-cream/50 line-through" data-id="element-120">
                  $14.99
                </span>
                <span className="text-xs text-cream font-bold ml-1" data-id="element-121">
                  GRATIS
                </span>
              </div>
            </div>
            <div className="z-30" data-id="element-122">
              <BookMockup title="Primeros Bocados" size="lg" data-id="element-123" />
            </div>
            <div className="z-20 transform -translate-x-8 translate-y-4 rotate-[5deg] relative" data-id="element-124">
              <BookMockup title="La Despensa" variant="bonus2" size="sm" data-id="element-125" />
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-center" data-id="element-126">
                <span className="text-xs text-cream/50 line-through" data-id="element-127">
                  $12.99
                </span>
                <span className="text-xs text-cream font-bold ml-1" data-id="element-128">
                  GRATIS
                </span>
              </div>
            </div>
            <div className="z-10 transform -translate-x-16 translate-y-8 rotate-[10deg] relative" data-id="element-129">
              <BookMockup title="30 Recetas" variant="bonus3" size="sm" data-id="element-130" />
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-center" data-id="element-131">
                <span className="text-xs text-cream/50 line-through" data-id="element-132">
                  $19.99
                </span>
                <span className="text-xs text-cream font-bold ml-1" data-id="element-133">
                  GRATIS
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div className="text-center space-y-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-134">
            <div className="flex items-center justify-center gap-4" data-id="element-135">
              <span className="bg-cream/20 text-cream text-sm font-bold px-3 py-1 rounded-full border border-cream/30" data-id="element-136">
                -66%
              </span>
              <span className="text-xl text-cream/50 line-through font-serif" data-id="element-137">
                $29.00
              </span>
              <span className="text-4xl font-serif text-cream" data-id="element-138">$9.99</span>
            </div>
            <a href="https://epikkastore.com/cart/45054208213015:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="bg-cream hover:bg-white text-olive px-12 py-5 rounded-xl font-bold text-lg transition-colors shadow-xl inline-block text-center" data-id="element-139">
              Comprar ahora
            </a>
            <p className="text-sm text-cream/60 uppercase tracking-widest" data-id="element-140">
              Acceso digital inmediato
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}